import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useCurrentUser, useIsCurrentUserVoltEmployee } from "modules/auth";
import { CustomersApi } from "modules/customers";
import {
  clearGlobalFilteredCustomer,
  selectGlobalFilteredCustomer,
} from "store/appSlice";

export function useGlobalFilter() {
  const dispatch = useDispatch();

  const isVoltEmployee = useIsCurrentUserVoltEmployee();
  const { currentUser, isLoading: isLoadingUser } = useCurrentUser();

  const globalPersistedFilteredCustomer = useSelector(
    selectGlobalFilteredCustomer
  );
  const customerId =
    !isVoltEmployee && !globalPersistedFilteredCustomer
      ? currentUser?.customer?.id ?? ""
      : globalPersistedFilteredCustomer?.id ?? "";

  const {
    data: customer,
    isLoading: isLoadingCustomer,
    isError,
  } = CustomersApi.useGetCustomerQuery(
    { id: customerId },
    { skip: !customerId }
  );

  const isGlobalFiltering = Boolean(globalPersistedFilteredCustomer?.id);

  const isLoading = isLoadingCustomer || isLoadingUser;

  const globallyFilteredCustomer =
    (!isVoltEmployee || isGlobalFiltering) && !isLoading
      ? customer ?? null
      : null;

  const handleCustomerClear = useCallback(() => {
    dispatch(clearGlobalFilteredCustomer());
  }, [dispatch]);

  return {
    isError,
    isGlobalFiltering,
    isLoading,
    globallyFilteredCustomer,
    handleCustomerClear,
  };
}
